import type { MeterWhere } from "@tillix/db/validators/MeterWhere";
import { ExtendedModel } from "mobx-keystone";
import { api } from "../../../orpc/client";
import { createTStore, type TStoreInit } from "../../lib/models/create-t-store";
import { TStore } from "../../lib/models/t-store";
import { MeterModel } from "./model.meter";
import { meterNS } from "./ns.meter";

type MeterWhereInput = typeof MeterWhere.infer;

@meterNS.store
export class MeterStore extends ExtendedModel(
  TStore<MeterModel, MeterWhereInput, typeof api.pluginData.utilities.meter>,
  {},
) {
  Model = MeterModel;
  api = api.pluginData.utilities.meter;
}

export const createMeterStore = (
  incomingData?: TStoreInit<MeterModel, MeterStore>,
) => createTStore<MeterModel, MeterStore>(MeterStore, incomingData);
